/**
 * Main auth landing — routes via `app_config.main_screen_variant`:
 * classic (v1 tiles), banner_guest (v2), hero_dock (v3).
 */
import React from 'react';
import { useMainScreenVariant } from '../data/domains/config';
import { useReportSplashPageReady } from '../lib/useReportSplashPageReady';
import MainScreenClassic from './MainScreenClassic';
import MainScreenBannerGuest from './MainScreenBannerGuest';
import MainScreenHeroDock from './MainScreenHeroDock';

const MainScreen = () => {
  const main_screen_variant = useMainScreenVariant();
  /** Classic reports readiness itself (banner paint). Other variants mark ready on mount. */
  const is_classic = main_screen_variant !== 'hero_dock' && main_screen_variant !== 'banner_guest';
  useReportSplashPageReady(!is_classic);

  if (main_screen_variant === 'hero_dock') {
    return <MainScreenHeroDock />;
  }
  if (main_screen_variant === 'banner_guest') {
    return <MainScreenBannerGuest />;
  }
  return <MainScreenClassic />;
};

export default MainScreen;
